import { REPORTING_FUNDING } from '../actionTypes';

export const fetchFundingReporting = (payload) => ({
  type: REPORTING_FUNDING.FETCH,
  payload,
});
